import request from '@/utils/request';

export function getStoreInfo() {
  return request('/user/store', {
    method: 'GET',
    // data: values,
  });
}
